import { create } from "zustand";

export type SupportView = "menu" | "guides";

interface SupportStore {
  open: boolean;
  view: SupportView;
  openSupport: (view?: SupportView) => void;
  close: () => void;
  setView: (view: SupportView) => void;
}

export const useSupportStore = create<SupportStore>(set => ({
  open: false,
  view: "menu",
  openSupport: (view = "menu") => set({ open: true, view }),
  close: () => set({ open: false, view: "menu" }),
  setView: view => set({ view }),
}));
